import React from 'react';
import VirtualPetHub from './VirtualPet/VirtualPetHub';

const VirtualPetPage: React.FC = () => {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '24px 16px',
        background: 'var(--Color-background-main, #F4F6FA)',
        boxSizing: 'border-box'
      }}
    >
      <div style={{ width: '100%', maxWidth: '1320px', display: 'flex', justifyContent: 'center' }}>
        <VirtualPetHub />
      </div>
    </div>
  );
};

export default VirtualPetPage;
